import { useTokens } from "@gemini/core";
import { useMediaQuery } from "./useMediaQuery";
/**
 * The viewport is evaluated on CSR using a "max-width: **1023px**" query.
 * Returns **true** by default during SSR.
 *
 * ### Usages
 *
 * ```tsx
 * const isTablet = useIsTablet()
 *
 * ```
 * ### SSR value
 * Best practice is to always mount components during SSR, regardless of the viewport
 * To that intent, useIsTablet hook always returns true during SSR
 */
export const useIsTablet = () => {
    const tokens = useTokens();
    const lg = tokens["breakpoint.lg"] || 1024;
    return useMediaQuery(`(max-width: ${lg - 1}px)`);
};
